import { createFileRoute } from '@tanstack/react-router'
import PlusIcon from '~/components/icons/PlusIcon'
import { EstablishmentsPanel } from '~/components/routes/sellers/EstablishmentsPanel'
import { SellersPageLayout } from '~/components/routes/sellers/sellers-page-layout'
import { useRights } from '~/utils/hooks'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/sellers/establishments')({
  staticData: {
    permission: ['read', 'sellers'],
  },
  component: EstablishmentsTabPage,
})
withRoutePermissions(Route)

function EstablishmentsTabPage() {
  const isAdmin = useRights(['ADMIN'])

  return (
    <SellersPageLayout
      activeTab="establishments"
      actions={
        <AuthorizedButtonLink
          variant="contained"
          to="/sellers/establishment/new"
          disabled={!isAdmin}
        >
          <PlusIcon />
          Ajouter un établissement
        </AuthorizedButtonLink>
      }
    >
      <EstablishmentsPanel />
    </SellersPageLayout>
  )
}
